import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MenuItem from './menuItem'
import MenuTree from './menuTree'
import { withRouter } from 'react-router-dom';

import { carregarUsuario } from '../../auth/authActions';

class Menu extends Component {

	state = {
		acessoAberto: null,
		configuracaoAberto: null,
		cadastroAberto: null
	}

	constructor(props) {
		super(props);

		let idInterval = setInterval(() => {
			if (this.props.usuario) {
				this.props.carregarUsuario();
				clearInterval(idInterval);
			}
		}, 2000);
	}

	render() {

		let selecionado = '';
		if (this.props.location && this.props.location.pathname) {
			selecionado = this.props.location.pathname;
		}

		if (this.props.usuarioCarregado) {
			if (!this.props.usuarioCarregado.permissao_acesso && (selecionado == '/usuario')) {
				window.location = '/';
			}
		}

		if (selecionado != '/' && this.state.acessoAberto == null && this.state.configuracaoAberto == null
			&& this.state.cadastroAberto == null) {
			if (selecionado == '/usuario') {
				this.setState({
					...this.state,
					acessoAberto: true
				});
			}
			
			if (selecionado == '/compraStatus' || selecionado == '/compraCategoria' 
				|| selecionado == '/compraTipo' || selecionado == '/prioridade' || selecionado == '/formaPagamento') {
				this.setState({
					...this.state,
					configuracaoAberto: true
				});
			}

			if (selecionado == '/cliente' || selecionado == '/fornecedor' || selecionado == '/transportadora' || selecionado == '/produto') {
				this.setState({
					...this.state,
					cadastroAberto: true
				});
			}
		}
		
		
		return (
			<nav className="mt-2">
								    
				<ul className="nav nav-pills nav-sidebar flex-column nav-flat nav-compact" data-widget="treeview" role="menu" data-accordion="false">
					<MenuItem path='/' label='Dashboard' icon='fas fa-tachometer-alt' active={selecionado == '/'} />
					
					{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_acesso) &&
					<MenuTree icon={'fas fa-user-lock'} label={'Acesso'}
						display={this.state.acessoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								acessoAberto: !this.state.acessoAberto,
							})
						} >
						<MenuItem submenu path='usuario' label='Usuário' icon='fas fa-id-card-alt' active={selecionado == '/usuario'} />
					</MenuTree>}

					{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_configuracao) &&
					<MenuTree icon={'fas fa-cog'} label={'Configuração'}
						display={this.state.configuracaoAberto}
						onClick={() =>
							this.setState({
								...this.state,
								configuracaoAberto: !this.state.configuracaoAberto,
							})
						} >
						<MenuItem submenu path='compraStatus' label='Status da Compra' icon='fas fa-stream' active={selecionado == '/compraStatus'} />
						<MenuItem submenu path='compraCategoria' label='Categoria da Compra' icon='fas fa-tags' active={selecionado == '/compraCategoria'} />
						<MenuItem submenu path='compraTipo' label='Tipo da Compra' icon='fas fa-list' active={selecionado == '/compraTipo'} />
						<MenuItem submenu path='prioridade' label='Prioridade' icon='fas fa-thermometer-three-quarters' active={selecionado == '/prioridade'} />
						<MenuItem submenu path='formaPagamento' label='Forma de Pagamento' icon='fas fa-hand-holding-usd' active={selecionado == '/formaPagamento'} />
					</MenuTree>}

					{(this.props.usuarioCarregado && this.props.usuarioCarregado.permissao_cadastro) &&
					<MenuTree icon={'fas fa-th-list'} label={'Cadastro'}
						display={this.state.cadastroAberto}
						onClick={() =>
							this.setState({
								...this.state,
								cadastroAberto: !this.state.cadastroAberto,
							})
						} >
						<MenuItem submenu path='cliente' label='Cliente' icon='fas fa-user-tie' active={selecionado == '/cliente'} />
						<MenuItem submenu path='fornecedor' label='Fornecedor' icon='fas fa-industry' active={selecionado == '/fornecedor'} />
						<MenuItem submenu path='transportadora' label='Transportadora' icon='fas fa-truck' active={selecionado == '/transportadora'} />
						<MenuItem submenu path='produto' label='Produto' icon='fas fa-table' active={selecionado == '/produto'} />
					</MenuTree>}

					{(this.props.usuarioCarregado && (
						this.props.usuarioCarregado.permissao_solicita_compra
						|| this.props.usuarioCarregado.permissao_gerencia_compra
						|| this.props.usuarioCarregado.permissao_visualiza_compra
					)) &&
					<MenuItem path='solicitacaoCompra' label='Solicitação' icon='fas fa-clipboard-list' active={selecionado == '/solicitacaoCompra'} />}
					{(this.props.usuarioCarregado && (
						this.props.usuarioCarregado.permissao_gerencia_pedido
						|| this.props.usuarioCarregado.permissao_visualiza_pedido
					)) &&
					<MenuItem path='pedido' label='Pedido' icon='fas fa-cart-plus' active={selecionado == '/pedido'} />}
				</ul>
			</nav>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado
});
const mapDispatchToProps = dispatch => bindActionCreators({ carregarUsuario }, dispatch);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));
